import { getBuildInfo } from '../lib/build-info';

/**
 * Tiny, always-visible build stamp for the sidebar footer. The whole point is
 * that it lands in a customer's screenshot, so we can tell which version + commit
 * they were running. Clicking it copies the full details for a bug report.
 *
 * Hidden when the sidebar is collapsed to icons (matches the rest of the footer).
 */
export function BuildInfoBadge({ appName }: { appName?: string }) {
  const info = getBuildInfo();

  const detailLines = [
    appName,
    `version ${info.version}`,
    `commit ${info.sha}`,
    info.builtAt ? `built ${info.builtAt}` : null,
    `env ${info.env}`,
  ].filter(Boolean) as string[];
  const detail = detailLines.join('\n');

  const copy = () => {
    void navigator.clipboard?.writeText(detailLines.join(' · '));
  };

  return (
    <button
      type="button"
      onClick={copy}
      title={`${detail}\n\n(click to copy)`}
      aria-label={`Build ${info.version}, commit ${info.shortSha}. Click to copy build details.`}
      className="group-data-[collapsible=icon]:hidden w-full px-2 pt-1 text-left font-mono text-[10px] leading-tight text-muted-foreground/60 hover:text-muted-foreground transition-colors truncate"
    >
      v{info.version} · {info.shortSha}
    </button>
  );
}
